import type { AppProps, ProjectType, ProjectTypeId } from '../model/types.tsx';
import type { State } from './types.tsx';

export const getAppProps = (state: State): AppProps => state.appProps;

export const getProjectTypes = (state: State): ReadonlyArray<ProjectType> =>
	state.appProps.projectTypes;

export const getSelectedProjectTypes = (state: State): ReadonlyArray<ProjectTypeId> =>
	state.selected;
export const getAriaText = (state: State) => state.appProps.ariaLabelText;
